module.exports = __webpack_public_path__ + "static/media/copiri_logo.75a10342.png";